import StoreOutlinedIcon from "@mui/icons-material/StoreOutlined";
import { LineasMultiples } from "./LineasMultiples";
import React, { useState, useEffect } from "react";

export const LineaMultiplesPedidosVentas = ({ Fecha, WidgetKey }) => {

  const dataDBTipos = [
    { value: 'Pedidos', name: 'Pedidos' },
    { value: 'Ventas', name: 'Ventas' },
  ];

  const [loading, setLoading] = useState(true)
  const [data, setData] = useState([])
  const { Varios: { FormateoFechaPara_yyyyMMdd } } = require('neftis7_apicaller');
  const { CONT_Reportes: { function_CONT_Reportes_ReportePedidosVsVentas } } = require('neftis7_apicaller');

  const getData = async () => {
    // Llama a función asíncrona y maneja los datos
    try {
      let fechaDesde = new Date(Fecha); // Copia la fecha de Fecha
      fechaDesde.setDate(Fecha.getDate() - 365);

      const resultData = await function_CONT_Reportes_ReportePedidosVsVentas(await FormateoFechaPara_yyyyMMdd(fechaDesde), await FormateoFechaPara_yyyyMMdd(Fecha));
      setData(resultData.data)
    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
    setLoading(false)
  };

  useEffect(() => {
    getData();
  }, [Fecha, WidgetKey]);

  const dataFinal = {
    title: "PEDIDOS y VENTAS (ANUAL)",
    icon: (
      <StoreOutlinedIcon
        className="icon"
        style={{
          backgroundColor: "lightseagreen",
          color: "green",
          width: "30px",
          height: "30px",
          margin: "0px 15px 0px 0px "
        }}
      />
    ),
  };

  return (
    <div>
      {data.length > 0 && (
        <LineasMultiples
          icono={dataFinal.icon}
          titulo={dataFinal.title}
          dataSourceTipos={dataDBTipos}
          dataSourceDatos={data}
          PaletaColor="Violet"
        />
      )}
    </div>
  );
};